import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CeiUserPhotoService } from '@cei-ufg/ngx-arquitetura-cei-frontend';

@Injectable({ providedIn: 'root' })
export class PessoaPhotoService {
  private readonly userPhotoService = inject(CeiUserPhotoService);

  fetchAuthenticatedPhotoUrl(pessoaId: number, cacheKey = `pessoa-${pessoaId}`): Observable<string | undefined> {
    if (!pessoaId) {
      return of(undefined);
    }

    return this.userPhotoService.fetchAuthenticatedPhotoUrl(`/api/pessoa/${pessoaId}/foto/`, cacheKey);
  }

  revoke(cacheKey: string): void {
    this.userPhotoService.revoke(cacheKey);
  }

  revokeAll(): void {
    this.userPhotoService.revokeAll();
  }
}
